module.exports = __webpack_public_path__ + "public/images/puzzles.e98be88db66644987b24c1c07f35b8df.png";